//Поисковая строка

import React from 'react';
import './Search.css';

export function Search(props) {

  return ( 
      <label className="search__label">
        <input 
          className="search__input" 
          value={props.keyword || ''}  
          onChange={props.onSearch} 
          name="search" 
          autoComplete='off'
          placeholder={props.placeholder} 
          type="search" 
          id="search" 
        />  
    
      </label>
   
  ) 
}
